import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';

const routes: Routes = [
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: '', redirectTo: 'partner', pathMatch: 'full' },

  {
    path: 'partner',
    loadChildren: () => import('./partner2/partner2.module').then((m) => m.Partner2Module)
  },
  {
    path: 'lead',
    loadChildren: () => import('./lead/lead.module').then((m) => m.LeadModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule)
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./usuarios/usuarios.module').then((m) => m.UsuariosModule)
  },
  {
    path: 'partner-user',
    loadChildren: () => import('./partner-user2/partner-user2.module').then((m) => m.PartnerUser2Module)
  },
  {
    path: 'partner-user2',
    loadChildren: () => import('./partner-user2/partner-user2.module').then((m) => m.PartnerUser2Module)
  },
  {
    path: 'menu',
    loadChildren: () => import('./menuedit/menuedit.module').then((m) => m.MenuModule)
  },
  {
    path: 'liquidation',
    loadChildren: () => import('./liquidation/liquidation.module').then((m) => m.LiquidationModule)
  },
  {
    path: 'contract-template',
    loadChildren: () => import('./contract-template/contract-template.module').then((m) => m.ContractTemplateModule)
  },
  {
    path: 'user-partner-user-type',
    loadChildren: () => import('./user-partner-user-type/user-partner-user-type.module').then((m) => m.UserPartnerUserTypeModule)
  },
  {
    path: 'role-partner-user-type',
    loadChildren: () => import('./role-partner-user-type/role-partner-user-type.module').then((m) => m.RolePartnerUserTypeModule)
  },
  {
    path: 'roles',
    loadChildren: () => import('./roles/roles.module').then((m) => m.RolesModule)
  },
  {
    path: 'user-roles',
    loadChildren: () => import('./user-roles-admin/user-roles-admin.module').then((m) => m.UserRolesAdminModule)
  },
  {
    path: 'prescriptores',
    loadChildren: () => import('./prescriptores/prescriptores.module').then((m) => m.PrescriptoresModule)
  },
  {
    path: 'commission',
    loadChildren: () => import('./commission/commission.module').then((m) => m.CommissionModule)
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule)
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
